/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionDuplicationCheckPayloadDto
 */
export interface SubmissionDuplicationCheckPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof SubmissionDuplicationCheckPayloadDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDuplicationCheckPayloadDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionDuplicationCheckPayloadDto
     */
    inceptionDate: Date;
}

/**
 * Check if a given object implements the SubmissionDuplicationCheckPayloadDto interface.
 */
export function instanceOfSubmissionDuplicationCheckPayloadDto(value: object): value is SubmissionDuplicationCheckPayloadDto {
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    if (!('inceptionDate' in value) || value['inceptionDate'] === undefined) return false;
    return true;
}

export function SubmissionDuplicationCheckPayloadDtoFromJSON(json: any): SubmissionDuplicationCheckPayloadDto {
    return SubmissionDuplicationCheckPayloadDtoFromJSONTyped(json, false);
}

export function SubmissionDuplicationCheckPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionDuplicationCheckPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'],
        'lineOfBusiness': json['lineOfBusiness'],
        'inceptionDate': (new Date(json['inceptionDate'])),
    };
}

export function SubmissionDuplicationCheckPayloadDtoToJSON(json: any): SubmissionDuplicationCheckPayloadDto {
    return SubmissionDuplicationCheckPayloadDtoToJSONTyped(json, false);
}

export function SubmissionDuplicationCheckPayloadDtoToJSONTyped(value?: SubmissionDuplicationCheckPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'lineOfBusiness': value['lineOfBusiness'],
        'inceptionDate': ((value['inceptionDate']).toISOString()),
    };
}

